import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { COOKIES } from '../../brands/default/constants';
import { setCookie } from '../../helpers/cookieSetter';
import { setLocation } from '../../redux/actions/locations';
import { getGeoLocationData } from '../../services/geoLocation';

const GeoLocation = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function ({
      coords: { latitude, longitude },
    }) {
      const setUserSelectedLocation = async () => {
        const data = await getGeoLocationData(latitude, longitude);
        if (data) {
          dispatch(setLocation(data, true));
        }
        // Set cookie to make sure this component only fires once
        setCookie({
          expire: 365,
          key: COOKIES.googleLocation,
          value: 'b',
        });
      };

      setUserSelectedLocation();
    });
  }, []);

  return <></>;
};

export default GeoLocation;
